/* eslint-disable max-lines */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import isEmpty from "lodash.isempty";
import get from "lodash.get";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Typography from "../../components/atoms/typography";
import {
  labelStyle,
  constants,
  productTypes,
  metrics,
  SALE_NUDGE,
  newLabelStyle,
} from "../../constants/pageConstants/pdpConstants";
import { COUNTRIES, FORMAT, LOCAL_CURRENCY, MAKE_IT_EXTRA_SPECIAL } from "../../constants/common/common";
import { setCatalogId, setIsMobile } from "../../store/slices/common/appConfig";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storage/localStorageUtil";
import CookieUtil from "../../utils/storage/cookieUtil";
import {
  setClientCurrentClickedItem,
  setClientVariantsLabel,
  setClientVariantType,
  setDeliveryType,
  setFullProductDetails,
  setClientFlavorType,
  setFlavorListForCakeTypeProduct,
  requestToFetchProductStockAvailable,
  responseFromFetchProductStockAvailable,
  requestIsSwipeEnable,
} from "../../store/slices/pdpSlice";
import {
  checkIsInternationalProduct,
  getOutOfStock,
  isNonDeliverable,
  isNonDeliverableAbroad,
  isSameSkuProduct,
} from "../../utils/pdp/nonDeliverable";
import {
  setDeliveryDetailsAction,
  setProductDeliveryShippingDetailsAction,
} from "../../store/slices/common/shippingDateAndSlotSelection";
import useAnalytics from "../../analytics/useAnalytics";
import { checkIsDigitalProduct, generateFlavorTypeList } from "../../utils/pdp/common";
import { setSelectedDomesticLocation } from "../../store/slices/locationLock";
import { campaignEvents, cleverTapCommonEvents, duplicateCleverTapEvents } from "../../analytics/clevertapConstants";
import { nsaOrOutOfStockGaEvent, setGA4PdpPageGaEvent } from "../../analytics/gaEvents";
import { LAST_VISITED_PINCODE, PARTNER, SELECTED_INTERNATIONAL_CITY, HDFC_SMARTBUY } from "../../constants/storage";
import { GA4_EVENTS } from "../../analytics/gaConstant";
import { PageTypes, setPageType } from "../../utils/fnpPageType";
import useCleverTapPDPData from "../../customHooks/clevertap/pdp";
import ProductDisplayGallery from "../../components/molecules/productDisplayGallery";
import ProductPriceSection from "../../components/molecules/pdpProductPriceSection";
import ComboComponents from "../../components/molecules/comboComponents";
import AccordionSection from "./productDetailComponents/AccordionSection";
import Breadcrumb from "../../components/atoms/breadCrumb"; // make skeleton and then make it dynamic import
import HiddenInputs from "./productDetailComponents/pdpHiddenInputs";
import getFnpSalesChannelInfo from "../../utils/fnpChannelsInfo";
import Skeleton from "../../components/molecules/skeletons/skeleton";
import {
  buildPartnerMembershipFlags,
  isJsonString,
  onSmoothScrollToElement,
  removeEmptyNullAndUndefinedFromObject,
  restrictAutoScrollingOnLoad,
} from "../../utils/common";
import ExploreMore from "../../components/organisms/exploreMore";
import WebNativeDisplayBanners from "./productDetailComponents/WebNativeDisplayBanners";
import { execDataLayer } from "../../utils/cache-layer/cacheLayer";
import { getSaleNudgeConfig } from "../../api/pdpApi";
import { getProductsAttrTag } from "../../api/plpApi";
import { useABTestingView } from "../../customHooks/clevertap/useABTestingView";
import CategorySuggestionBanner from "../../components/molecules/CategorySuggestionBanner";
import AddonBody from "../../components/organisms/addonSelection/addonBody";
import {
  requestToFetchPdpAddOnInfoAction,
  requestToFetchPdpAddOnInfoNewAction,
  resetPdpAddOnState,
} from "../../store/slices/pdpAddonSlice";
import LottieLoader from "../../components/atoms/lottieLoader";
import { requestToSavedAddress } from "../../store/slices/savedAddresses";
import PlpSkeleton from "../../components/molecules/skeletons/plpSkeleton";
import useNavigationReset from "../../customHooks/useNavigationReset";
import { loadAccuracyWeightageOnIdle } from "../../api/common";
import SingleImageBannerSection from "../homePage/homeComponents/SingleImageBannerSection";
import CursorManager from "../../components/atoms/cursorManager/index.";
import { MapPinIcon } from "@phosphor-icons/react";
import {
  handlePersonalizationDetailsOnRefresh,
  hasStartedTextPersonalization,
  isInlineOptionalPersonalization,
  isProductPersonalizationComplete,
  isTextOnlyPersonalization,
  shouldShowPersonalizationCustomiseButton,
} from "../../utils/pdp/personalization";
import { setUserPersonalization } from "../../store/slices/personalizationSlice";
import useCustomizationCleverTap from "../../customHooks/clevertap/customization";
import { getInternationalDeliveryForRakhi } from "../../api/locationLock";

const FreeShippingInfo = dynamic(() => import("./productDetailComponents/FreeShippingInfo"), {
  ssr: false,
});
const PdpOffers = dynamic(() => import("../../components/organisms/pdp-offers"), {
  ssr: true,
  loading: () => <Skeleton customStyle={{ width: "100%", height: "150px" }} />,
});

const ClearCart = dynamic(() => import("../../components/organisms/clearCart"), { ssr: false });

const PayLater = dynamic(() => import("../../components/organisms/paylater"), { ssr: false });

const CommonConditionalComponents = dynamic(() => import("../../components/molecules/commonConditionalComponents"), {
  ssr: false,
});
const ZoomGallery = dynamic(() => import("../../components/molecules/zoomGallery"), {
  ssr: false,
});
const TrustMetrics = dynamic(() => import("../../components/molecules/trustMetrics"), {
  ssr: false,
});
const OneTapLogin = dynamic(() => import("../../components/organisms/googleOneTapLogin"), {
  ssr: false,
});
const DesktopLocationLockSection = dynamic(() => import("./productDetailComponents/desktopLocationLockSection"), {
  loading: () => <Skeleton customStyle={{ width: "100%", height: "50px" }} />,
});
const MobileLocationLockSection = dynamic(() => import("./productDetailComponents/mobileLocationLockSection"), {
  loading: () => <Skeleton customStyle={{ width: "100%", height: "50px" }} />,
});
const DeliveryDateAndtimeSlotSelection = dynamic(
  () => import("./productDetailComponents/deliveryDateAndtimeSlotSelectionSection"),
  {
    loading: () => <Skeleton customStyle={{ width: "100%", height: "50px" }} />,
  },
);
const ChooseDeliveryType = dynamic(() => import("./productDetailComponents/ChooseDeliveryType"), {
  loading: () => <Skeleton customStyle={{ width: "100%", height: "50px" }} />,
});

const ProductDetailWidgetSection = dynamic(() => import("./productDetailComponents/productDetailWidgetSection"));
const BuyNowSection = dynamic(() => import("./productDetailComponents/buyNowSection"), { ssr: false });
const PersonalizedOptionSection = dynamic(() => import("./productDetailComponents/personalizedOptionSection"));

/**
 * ProductDetailPage container that displays a product gallery.
 *
 * This container renders the ProductDisplayGallery with specific properties
 * tailored for mobile view. It uses constants from pdpConstants for the data
 * and rating information.
 *
 * @returns {JSX.Element} A React component that renders the product gallery.
 */
const ProductDetailPage = ({
  serverData,
  serverOffersData,
  serverVariantProducts,
  serverVariantLabel,
  serverVariantType,
  isMobile,
  fullProductDetails,
  serverSelectedCurrency,
  breadCrumb,
  catalogId,
  serverVariantFlavor,
  pdpFooterLinks = {},
  serverCustomerReviewData,
  monthlyOrdersCount,
  isShowFreeDeliveryTag = false,
  freeDeliveryText,
  freeBannerData,
}) => {
  useEffect(() => loadAccuracyWeightageOnIdle(), []);
  const dispatch = useDispatch();
  const { init, trackEvent } = useAnalytics();
  const { pdpTopSuggestion, payLater } = useABTestingView();
  const {
    selectedCurrencyFromState,
    clientCurrentClickedItem,
    deliveryDetails,
    deliveryDates,
    isLoading,
    deliveryType,
    shippingDetailsInternational,
    isUserLoggedIn,
    pincode,
    selectedIntLocation,
    requestToAddToCart,
    clientVariantLabel,
    deliveryDetailsData,
    userPersonalization,
    addOnInfo,
    isAutoScroll,
    savedAddresses,
    fullProductDetailsProductId,
    addToCartErrorMsg,
    isProductStockAvailable,
    selectedDate,
    isShowAddonsOnPDP,
    emailID,
    fullBannerData,
    isSwipeEnabled,
    flavorList,
    isShowCartEmpty,
    partner,
  } = useSelector(
    (state) => ({
      selectedCurrencyFromState: state?.currencyList?.userSelectedCurrency,
      clientCurrentClickedItem: state?.pdp?.clientCurrentClickedItem,
      deliveryDetails: state?.shippingDateAndSlotSelection,
      deliveryDates: state?.shippingDateAndSlotSelection?.deliveryDates,
      isLoading: state?.shippingDateAndSlotSelection?.loading,
      deliveryType: state?.pdp?.deliveryType,
      shippingDetailsInternational: state?.shippingDateAndSlotSelection?.internationalDeliveryMethods,
      isUserLoggedIn: state?.fus?.loginDetail?.loggedin,
      pincode: state?.locationLock?.selectedDomesticLocation?.pincode,
      selectedIntLocation: state?.locationLock.selectedIntLocation,
      requestToAddToCart: state?.cart?.requestToAddToCart,
      clientVariantLabel: state?.pdp?.clientVariantLabel,
      deliveryDetailsData: state?.shippingDateAndSlotSelection?.selectedDeliveryDetails,
      userPersonalization: state?.personalization?.userPersonalization,
      addOnInfo: state?.pdpAddon?.addOnInfo,
      isAutoScroll: state?.pdpAddon?.isAutoScroll,
      savedAddresses: state?.savedAddress?.savedAddresses || [],
      fullProductDetailsProductId: state?.pdp?.fullProductDetails?.productId,
      addToCartErrorMsg: state?.cart?.addToCartResponse?.errorMsg,
      isProductStockAvailable: state?.cart?.addToCartResponse?.isProductStockAvailable,
      selectedDate: state?.pdp?.selectedDate,
      isShowAddonsOnPDP: state?.webFeatureControls?.data?.isShowAddonsOnPDP,
      emailID: state?.loginSignUp?.userDetails?.emailID,
      fullBannerData: state?.webFeatureControls?.data?.plpPdpBanners,
      isSwipeEnabled: state?.pdp?.isSwipeEnabled,
      flavorList: state?.pdp?.flavorList,
      isShowCartEmpty: state?.locationLock?.isShowCartEmpty,
      partner: state?.fus?.loginDetail?.partner,
    }),
    shallowEqual,
  );
  const initialRender = useRef(false);
  const openPersonalizationDrawerRef = useRef(null);
  const trackCustomizationDoneRef = useRef(() => {});
  const wasPersonalizationCompleteRef = useRef(false);
  // Drawer Save & Continue completes synchronously (typing in the drawer never re-renders
  // this container, so trackCustomizationDoneRef can be a render behind). Firing from this
  // counter + effect instead of inline defers the call to the next commit, by which point
  // trackCustomizationDoneRef has been reassigned with the latest PDP state.
  const [customizationDoneTrigger, setCustomizationDoneTrigger] = useState(0);
  // Lives here (not inside AddonBody) because selecting a date resets/refetches
  // pdpAddon state, which unmounts/remounts AddonBody and would otherwise wipe
  // an in-component ref, letting addonViewed re-fire for the same pid/pincode/date.
  const pdpAddonViewedKeyRef = useRef("");
  const isNavigating = useNavigationReset();
  const [showBanner, setShowBanner] = useState(false);
  const [bannerData, setBannerData] = useState(null);
  const [campaignEventData, setCampaignEventData] = useState({});
  const [productsAttrTagData, setProductsAttrTagData] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState(serverSelectedCurrency || {});
  const currentItem = isEmpty(clientCurrentClickedItem) ? serverData : clientCurrentClickedItem;
  const { primaryCategoryId = "", productId = "", assocProductDetails = null, productTypeId = "" } = currentItem || {};
  const [isMounted, setIsMounted] = useState(false);
  const [isSmartBuyClient, setIsSmartBuyClient] = useState(false);
  const isSameSku = isSameSkuProduct(assocProductDetails);
  const isInternational = checkIsInternationalProduct(primaryCategoryId);
  const [isNotServiceable, setIsNotServiceable] = useState(false);
  const [isShowPayLater, setIsShowPayLater] = useState(false);
  const [isCustomisePreCheckoutOpen, setIsCustomisePreCheckoutOpen] = useState(false);
  const [isPreCheckoutOpen, setIsPreCheckoutOpen] = useState(false);
  // DeliveryDateAndtimeSlotSelection computes these from local state (redirection nudge
  // content, inline-calendar visibility); lifted here so the sibling BuyNowSection can
  // include them on the addToCart/buyNow CleverTap events.
  const [nudgeVisibility, setNudgeVisibility] = useState({
    isSameDayNudgeVisible: false,
    isLimitedCatalogueNudgeVisible: false,
  });
  const onNudgeVisibilityChange = useCallback((visibility) => {
    setNudgeVisibility(visibility);
  }, []);

  const isOutOfStock =
    !isProductStockAvailable && addToCartErrorMsg
      ? true
      : (getOutOfStock(currentItem?.productStockAvailable, productId, selectedDate) ?? true);

  const onPersonalizationDrawerReady = useCallback((openHandler) => {
    openPersonalizationDrawerRef.current = openHandler;
  }, []);

  const onOpenPersonalization = useCallback(() => {
    openPersonalizationDrawerRef.current?.();
  }, []);

  const personalizedInfo = get(currentItem, "personalizedInfo");
  const hasPersonalizedOptions = !isEmpty(personalizedInfo?.personalizedOptions);
  const [isPersonalizationComplete, setIsPersonalizationComplete] = useState(false);

  useEffect(() => {
    const isComplete = isProductPersonalizationComplete(productId, personalizedInfo);
    wasPersonalizationCompleteRef.current = isComplete;
    setIsPersonalizationComplete(isComplete);
  }, [productId, personalizedInfo]);

  const onPersonalizationCompleteChange = useCallback(
    (isComplete, options = {}) => {
      const justCompleted = Boolean(isComplete && options.fromSave && !wasPersonalizationCompleteRef.current);

      // Only consume the "first complete" gate on an explicit save. Drawer-close refresh
      // often runs before onPersonalizationSaved and would otherwise suppress Customization Done.
      if (options.fromSave) {
        wasPersonalizationCompleteRef.current = Boolean(isComplete);
      } else if (!isComplete) {
        wasPersonalizationCompleteRef.current = false;
      }

      setIsPersonalizationComplete(isComplete);

      if (justCompleted) {
        setCustomizationDoneTrigger((count) => count + 1);
      }

      if (!isComplete || !options.shouldScroll) {
        return;
      }

      const scrollOffset = isMobile ? 70 : 150;

      /**
       * Scrolls after completion; retries until the target node exists post-render.
       * @param {number} retries - Remaining retry attempts.
       */
      const performScroll = (retries = 8) => {
        if (currentItem?.hasPersonalizableUI) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          return;
        }

        const targetElement = document.getElementById("personalization_section");
        if (targetElement) {
          onSmoothScrollToElement("personalization_section", scrollOffset);
        } else if (retries > 0) {
          requestAnimationFrame(() => performScroll(retries - 1));
        }
      };

      requestAnimationFrame(() => performScroll());
    },
    [currentItem?.hasPersonalizableUI, isMobile],
  );

  // Fires on the render after Save & Continue completes, once trackCustomizationDoneRef has
  // been reassigned (below) with the latest currentItem/clientVariantType/deliveryDates-derived
  // fields — see the customizationDoneTrigger declaration above for why this can't fire inline.
  useEffect(() => {
    if (customizationDoneTrigger > 0) {
      trackCustomizationDoneRef.current?.();
    }
  }, [customizationDoneTrigger]);

  const onCustomisePreCheckoutOpenChange = useCallback((isOpen) => {
    setIsCustomisePreCheckoutOpen(isOpen);
  }, []);

  // While the standard ATC/Buy Now PreCheckoutDrawer is open collecting location/delivery date,
  // this page's own (non-drawer) Delivery Date section stays mounted behind it and would otherwise
  // react to the same Redux location/date state and fire duplicate/premature CleverTap events.
  const onPreCheckoutOpenChange = useCallback((isOpen) => {
    setIsPreCheckoutOpen(isOpen);
  }, []);

  const isInlinePersonalization = isInlineOptionalPersonalization(personalizedInfo);
  const showCustomiseNowButton =
    hasPersonalizedOptions &&
    !isNotServiceable &&
    !isInlinePersonalization &&
    shouldShowPersonalizationCustomiseButton(productId, personalizedInfo);
  const isTextPersonalizationStarted =
    isTextOnlyPersonalization(personalizedInfo) && hasStartedTextPersonalization(productId, personalizedInfo);

  useEffect(() => {
    const savedPersonalization = handlePersonalizationDetailsOnRefresh(productId);
    dispatch(setUserPersonalization(Array.isArray(savedPersonalization) ? savedPersonalization : []));
  }, [productId, dispatch]);

  const currency = CookieUtil.getCookie(LOCAL_CURRENCY);
  const lastVisitedPincode = CookieUtil.getCookie(LAST_VISITED_PINCODE);
  const selectedIntlCity = CookieUtil.getCookie(SELECTED_INTERNATIONAL_CITY);
  const selectedCountry = selectedIntlCity && JSON.parse(selectedIntlCity);
  const cityOrPincode = !isInternational ? pincode : selectedIntLocation?.pincode;
  const searchParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;

  const hasDirectlyLandedFromGoogle =
    searchParams?.has("srsltid") || Array.from(searchParams?.keys() || []).some((key) => key.startsWith("utm_"));

  const properties = setGA4PdpPageGaEvent(
    currentItem,
    lastVisitedPincode,
    isUserLoggedIn ? true : false,
    currency,
    fullProductDetails,
    clientVariantLabel,
    catalogId,
    selectedCountry?.[catalogId.toUpperCase()]?.city,
  );

  useEffect(() => {
    setIsSmartBuyClient(CookieUtil.getCookie(PARTNER) === HDFC_SMARTBUY);
    setIsMounted(true);
  }, []);

  useEffect(() => {
    CookieUtil.setCookie(constants?.CURRENT_PRODUCT_ID, serverData?.productId, {
      maxAge: 2 * 24 * 60 * 60, // 2 days
      path: "/",
    });
    /**
     * fetchProductsAttrTag - Fetch product attribute tags client-side
     */
    const fetchProductsAttrTag = async () => {
      try {
        const response = await getProductsAttrTag();
        if (response && !response.status) {
          setProductsAttrTagData(response);
        }
      } catch (error) {
        console.log("Error fetching productsAttrTag", error);
      }
    };

    fetchProductsAttrTag();
    dispatch(requestIsSwipeEnable());
  }, []);

  useEffect(() => {
    if (!isInternational && payLater && isSwipeEnabled === "Y" && !isSmartBuyClient) {
      setIsShowPayLater(true);
    }
  }, [isInternational, payLater, isSwipeEnabled, isSmartBuyClient]);

  useEffect(() => {
    if (
      deliveryDetailsData?.currentShippingMethod?.shippingMethodId &&
      deliveryDetailsData?.timeSlots?.timeSlots?.timeSlotId
    ) {
      const addonPayload = {
        FNP_CURRENT_CATALOG_ID: catalogId,
        addProductId: fullProductDetails?.isVirtual === "Y" ? currentItem?.productId : fullProductDetailsProductId,
        productType: currentItem?.primaryCategoryId,
        shippingMethod: deliveryDetailsData?.currentShippingMethod?.shippingMethodId,
        timeSlotId: deliveryDetailsData?.timeSlots?.timeSlots?.timeSlotId,
        format: FORMAT.JSON,
        isbuynow: "N",
        pinCode: isInternational ? selectedIntLocation?.pincode : pincode,
        productId: fullProductDetails?.isVirtual === "Y" ? currentItem?.productId : fullProductDetailsProductId,
        ...(isInternational && { date: deliveryDetailsData?.selectedDate }),
      };
      dispatch(requestToFetchPdpAddOnInfoAction(addonPayload));
    }
    // `setDeliveryDetailsAction` returns a new object reference on every dispatch even when
    // the values are unchanged, so depend on the actual fields this effect cares about —
    // otherwise redundant re-selections of the same date (e.g. on fulfillment-type switch)
    // would re-fire this fetch. International also keys off the date, because the date-only
    // fetch below is skipped once a shipping method and time slot are selected.
  }, [
    deliveryDetailsData?.currentShippingMethod?.shippingMethodId,
    deliveryDetailsData?.timeSlots?.timeSlots?.timeSlotId,
    isInternational ? deliveryDetailsData?.selectedDate : undefined,
  ]);

  useEffect(() => {
    const isInternationalShippingSelected =
      isInternational &&
      deliveryDetailsData?.currentShippingMethod?.shippingMethodId &&
      deliveryDetailsData?.timeSlots?.timeSlots?.timeSlotId;
    if (deliveryDetailsData?.selectedDate && !isInternationalShippingSelected) {
      const addonPayload = {
        FNP_CURRENT_CATALOG_ID: catalogId,
        addProductId: fullProductDetails?.isVirtual === "Y" ? currentItem?.productId : fullProductDetailsProductId,
        productType: currentItem?.primaryCategoryId,
        isbuynow: "No",
        format: "json",
        pinCode: isInternational ? selectedIntLocation?.pincode : pincode,
        productId: fullProductDetails?.isVirtual === "Y" ? currentItem?.productId : fullProductDetailsProductId,
        date: deliveryDetailsData?.selectedDate,
      };
      dispatch(requestToFetchPdpAddOnInfoNewAction(addonPayload));
    }
    // Same rationale as the effect above — key off the actual selectedDate value, not the
    // whole (always-new-reference) deliveryDetailsData object.
  }, [deliveryDetailsData?.selectedDate]);

  useEffect(() => {
    if (addOnInfo.addonsList?.[0]?.products.length > 0 && isAutoScroll) {
      const isPersonalizationSection = document.getElementById("personalization_section");
      if (isPersonalizationSection) {
        onSmoothScrollToElement("personalization_section", isMobile ? 70 : 150);
      } else {
        onSmoothScrollToElement("pdpAddons", isMobile ? 70 : 150);
      }
    }
  }, [addOnInfo?.addonsList?.[0]?.products.length, isAutoScroll, isMobile]);

  useEffect(() => {
    if (!cityOrPincode || isLoading) {
      setIsNotServiceable(false);
      return;
    }
    const noService = !isInternational
      ? isNonDeliverable(deliveryDates, assocProductDetails, primaryCategoryId)
      : isNonDeliverableAbroad(shippingDetailsInternational?.isShippingDetailsExists);
    setIsNotServiceable(noService);
  }, [deliveryDates, shippingDetailsInternational, cityOrPincode, isLoading]);

  // Clear PDP addons when delivery location changes; they refetch after a new date/slot is selected.
  useEffect(() => {
    dispatch(resetPdpAddOnState());
    dispatch(setDeliveryDetailsAction({}));
  }, [cityOrPincode, dispatch]);

  // Also clear addons when the product is not serviceable at the selected location.
  useEffect(() => {
    if (isNotServiceable) {
      dispatch(resetPdpAddOnState());
      dispatch(setDeliveryDetailsAction({}));
    }
  }, [isNotServiceable, dispatch]);

  useEffect(() => {
    const nsaOrOutofStock = nsaOrOutOfStockGaEvent(
      pincode || lastVisitedPincode,
      !isEmpty(clientCurrentClickedItem) ? clientCurrentClickedItem : serverData,
    );
    if (isNotServiceable && (pincode || lastVisitedPincode)) {
      trackEvent(GA4_EVENTS?.NSA, { ...nsaOrOutofStock }, ["ga4"]);
    }
    if (isOutOfStock) {
      trackEvent(GA4_EVENTS?.OUT_OF_STOCK, { ...nsaOrOutofStock }, ["ga4"]);
    }
  }, [isNotServiceable, pincode, isOutOfStock]);

  const { commonCleverTapData, cleverTapPageData, cleverTapPDPEventData, duplicateEventData } = useCleverTapPDPData({
    currentItem,
    serverData,
    selectedCurrency,
    deliveryDates,
    isOutOfStock,
    isSameSku,
    catalogId,
  });
  const { trackCustomizationDone } = useCustomizationCleverTap({
    baseCleverTapData: cleverTapPageData,
    currentItem,
    isOutOfStock,
    isSameSku,
    isInternational,
    deliveryDates,
    nextAvailableDifference: deliveryDetails?.nextAvailableDifference,
    isSmartBuyUser: isSmartBuyClient,
    productUrl: cleverTapPageData?.clean_url,
  });
  trackCustomizationDoneRef.current = trackCustomizationDone;
  const pdpImageViewedData = {
    pid: duplicateEventData?.pid || "",
    area: duplicateEventData?.area || "",
    city: duplicateEventData?.city || "",
    pincode: duplicateEventData?.pincode || "",
    system_pincode: duplicateEventData?.system_pincode || "",
    country: duplicateEventData?.country || "",
    sku_id: duplicateEventData?.sku_id || "",
    product_name: currentItem?.productName || "",
    is_international: isInternational,
    flow: "new",
  };

  useEffect(() => {
    const eventDataForCdp = {
      page_type: cleverTapPageData?.page_type,
      internal_source: cleverTapPageData?.internal_source,
      user_id: emailID || "",
      page_name: cleverTapPageData?.page_name,
      products: [
        {
          productId: cleverTapPageData?.pid,
          city: cleverTapPageData?.city,
          area: cleverTapPageData?.area,
          pincode: cleverTapPageData?.pincode,
          systemPincode: cleverTapPageData?.system_pincode,
          country: catalogId,
          productCategory: cleverTapPageData?.product_category,
          productName: cleverTapPageData?.product_name,
          skuId: cleverTapPageData?.sku_id,
          productRating: cleverTapPageData?.product_rating,
          productReviewCount: cleverTapPageData?.product_review_count,
          isVariantAvailable: cleverTapPageData?.is_variant_available,
          isEgg: cleverTapPageData?.is_egg,
          deliveryType: cleverTapPageData?.delivery_type,
          productPrice: cleverTapPageData?.product_price,
          currency: cleverTapPageData?.currency,
          strikePrice: cleverTapPageData?.strike_price,
          discountPercentage: cleverTapPageData?.discount_percentage,
          isProductAvailable: cleverTapPageData?.is_product_available,
          isInternational: isInternational,
          loginStatus: cleverTapPageData?.login_status,
          imageUrl: cleverTapPageData?.image_url,
        },
      ],
    };

    if (isUserLoggedIn && emailID) {
      trackEvent(cleverTapCommonEvents.pdpPageViewed, eventDataForCdp, ["CDP"]);
    } else if (isUserLoggedIn == false && !emailID) {
      trackEvent(cleverTapCommonEvents.pdpPageViewed, eventDataForCdp, ["CDP"]);
    }
  }, [isUserLoggedIn, emailID]);

  const saleNudgeConfigData = getLocalStorageItem(SALE_NUDGE);
  if (!saleNudgeConfigData) {
    execDataLayer(getSaleNudgeConfig, SALE_NUDGE);
  }
  useEffect(() => {
    if (productId && initialRender?.current) {
      const payload = { productId, pincode: cityOrPincode || "" };
      dispatch(requestToFetchProductStockAvailable(payload));
    }
    if (checkIsDigitalProduct(currentItem)) {
      const { geoId = "", displayText = "" } = currentItem?.shippingDisplayOptions?.defaultGeoDetails || {};
      dispatch(
        setSelectedDomesticLocation({
          pincode: geoId,
          address: displayText,
        }),
      );
    }
    initialRender.current = true;
  }, [productId]);

  useEffect(() => {
    if (Object.keys(selectedCurrencyFromState).length === 0) {
      if (serverSelectedCurrency?.currency?.id) {
        CookieUtil.setCookie(LOCAL_CURRENCY, serverSelectedCurrency?.currency?.id ?? "", {
          path: "/",
          sameSite: "lax",
          secure: true,
        });
      }
    } else {
      setSelectedCurrency(selectedCurrencyFromState);
    }
  }, [selectedCurrencyFromState]);
  useEffect(() => {
    dispatch(setIsMobile(isMobile));
    dispatch(setCatalogId(catalogId));
    dispatch(setClientCurrentClickedItem(serverData));
    dispatch(setClientVariantType(serverVariantType));
    dispatch(setClientVariantsLabel(serverVariantLabel));
    dispatch(setFullProductDetails(fullProductDetails));
    if (serverVariantFlavor) {
      dispatch(setClientFlavorType(serverVariantFlavor));
      dispatch(setFlavorListForCakeTypeProduct(generateFlavorTypeList(fullProductDetails?.variantProducts)));
    }
  }, [isMobile, serverData]);
  useEffect(() => {
    if (isUserLoggedIn && !savedAddresses.length) {
      dispatch(requestToSavedAddress());
    }
    if (selectedCurrency && isUserLoggedIn !== undefined) {
      const filteredDuplicateEventData = removeEmptyNullAndUndefinedFromObject(duplicateEventData);

      trackEvent(
        cleverTapCommonEvents.pdpPageViewed,
        { ...cleverTapPageData, is_smartbuy_user: isSmartBuyClient, ...buildPartnerMembershipFlags(partner) },
        ["clevertap"],
      );

      duplicateCleverTapEvents?.[PageTypes.PRODUCT]?.forEach((eventName) => {
        trackEvent(eventName, filteredDuplicateEventData, ["clevertap"]);
      });
    }
  }, [isUserLoggedIn]);

  useEffect(() => {
    /**
     * Handles the "CT_web_native_display" event and sets the appropriate state
     * based on the delivery topic.
     *
     * @param {object} event .
     */
    const handleEvent = (event) => {
      if (event.detail.kv.topic === "pdp_banner_campaign") {
        trackEvent(campaignEvents.RENDER_NOTIFICATION_VIEWED, { ...event?.detail }, ["clevertap"]);
        setCampaignEventData({ ...campaignEventData, [event.detail.msgId]: event?.detail });
        const campaignParsedData = isJsonString(event.detail.kv?.data) ? JSON.parse(event.detail.kv?.data) : [];
        campaignParsedData.map((item) => (item.campaign_id = event.detail.msgId));
        setBannerData({ ...event.detail.kv, data: campaignParsedData });
      }
    };

    document.addEventListener("CT_web_native_display", handleEvent);

    /**
     *  handlePageShow check whether page is served from bfCache
     * @param {*} event
     */
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    /**
     * set fnp page type for pdp page
     */
    setPageType(PageTypes.PRODUCT);

    restrictAutoScrollingOnLoad();
    /**
     * // Function to get unique recently viewed products
     * @returns
     */
    const getUniqueRecentlyViewedProducts = () => {
      try {
        // Retrieve the existing array from local storage
        const storedProducts = getLocalStorageItem("recentlyViewedProducts");
        const previousRecentlyViewedProducts = storedProducts ? JSON.parse(storedProducts || "[]") : [];

        // Ensure the product ID is unique before adding it
        if (currentItem?.productId && !previousRecentlyViewedProducts.includes(currentItem.productId)) {
          previousRecentlyViewedProducts.unshift(currentItem.productId);
          if (previousRecentlyViewedProducts.length > 40) {
            previousRecentlyViewedProducts.pop();
          }
        }

        return previousRecentlyViewedProducts;
      } catch (error) {
        console.error("Error accessing local storage:", error);
        return [];
      }
    };

    /**
     * Function to update local storage with unique products
     */
    const updateRecentlyViewedProducts = () => {
      const uniqueProducts = getUniqueRecentlyViewedProducts();
      setLocalStorageItem("recentlyViewedProducts", JSON.stringify(uniqueProducts));
    };

    // Update local storage with the new product ID
    updateRecentlyViewedProducts();
    dispatch(responseFromFetchProductStockAvailable(currentItem?.productStockAvailable));
    // Initialize analytic tools
    init();
    trackEvent(GA4_EVENTS?.VIEW_ITEM, { ...properties }, ["ga4"]);

    const getIntDeliveryRakhiFromStorage = getLocalStorageItem("getIntDeliveryForRakhi");
    if (!getIntDeliveryRakhiFromStorage) {
      // Fetch and set the flag value in local storage
      (async () => {
        await execDataLayer(getInternationalDeliveryForRakhi, "getIntDeliveryForRakhi");
      })();
    }

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener("CT_web_native_display", handleEvent);
    };
  }, []);

  useEffect(() => {
    dispatch(setDeliveryType(primaryCategoryId));
    if (deliveryDetails?.[productId]) {
      dispatch(
        setProductDeliveryShippingDetailsAction({
          deliveryDates: deliveryDetails?.[productId]?.deliveryDates,
          shippingDetails: deliveryDetails?.[productId]?.shippingDetails,
          earliestTimeSlot: deliveryDetails?.[productId]?.earliestTimeSlot,
          instantDeliveryWindow: deliveryDetails?.[productId]?.instantDeliveryWindow,
          isInstant: deliveryDetails?.[productId]?.isInstant,
          nextAvailableDifference: deliveryDetails?.[productId]?.nextAvailableDifference,
        }),
      );
    }
  }, [primaryCategoryId, deliveryDetails?.[productId]]);

  /** */
  const onGa4EventBuyNow_AddToCart = (eventType) => {
    trackEvent(eventType, { ...properties }, ["ga4"]);
  };

  /**
   * Function to handle the addition of a product video link to the product images.
   *
   * This function takes in product value and checks if a product video link is present.
   * If a video link exists, it appends the last image to the list of images and returns
   * the updated list. Otherwise, it simply returns the original list of product images.
   * @returns {Array} An array of product images, possibly including an additional image if a video link exists.
   */
  const getProductImages = (value) => {
    let productImages = get(value, "productContent.productImages");
    const hasPersonalizableUI = get(value, "hasPersonalizableUI");
    if (hasPersonalizableUI) {
      if (userPersonalization && userPersonalization.length > 0 && userPersonalization[0]?.previewImage) {
        productImages = [userPersonalization[0]?.previewImage, ...productImages];
      } else if (userPersonalization && userPersonalization.length > 0 && userPersonalization[0]?.value?.length > 0) {
        productImages = [userPersonalization[0]?.value[0], ...productImages];
      }
    }
    return productImages;
  };

  const containerPadding = "px-12 md:px-0";

  /**
   * Creates breadcrumb data based on the provided input.
   *
   * @param {Object} data - The data used to generate breadcrumbs.
   * @param {Object} data.data - The nested data object containing details.
   * @param {string} data.data.primaryCategoryId - The primary category ID, used for generating a category URL.
   * @param {string} data.data.productName - The product name, used for the final breadcrumb.
   * @returns {Array<Object>} An array of breadcrumb objects with `label` and `url` properties.
   */
  const createBreadcrumbsData = (data) => {
    const breadcrumbs = [
      {
        label: "Home",
        url: "/",
      },
    ];

    if (data?.label) {
      breadcrumbs.push({
        label: data.label,
        url: `/${data.url}`,
      });
    }

    if (data?.productName) {
      breadcrumbs.push({
        label: data.productName,
        url: "",
      });
    }

    return breadcrumbs;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pdpBannerData = fullBannerData?.pdp;
  const bannerDataObject = {
    banner_image_url: isMobile ? pdpBannerData?.banner_image_url : pdpBannerData?.desktop_banner_image_url,
    show_banner: isMobile ? pdpBannerData?.show_banner : pdpBannerData?.desktop_show_banner,
    is_full_width: isMobile ? pdpBannerData?.is_full_width : pdpBannerData?.desktop_is_full_width,
    category_link: isMobile ? pdpBannerData?.category_link : pdpBannerData?.desktop_category_link,
    altTag: "PDP Promotional Banner",
    dimensions: isMobile ? pdpBannerData?.dimensions : pdpBannerData?.desktop_dimensions,
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (bannerDataObject?.show_banner) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [bannerDataObject?.show_banner]);

  return (
    <div id="mainContent">
      <CursorManager />
      {/* loader code for msite INP issue */}
      {requestToAddToCart && <LottieLoader />}

      <OneTapLogin />
      {isNavigating && (
        <div className="fixed inset-0 z-50 mt-[92px] bg-white-900 md:mt-[35px]">
          <PlpSkeleton
            showHeader={true}
            showFilters={true}
            productCount={12}
            isMobile={isMobile}
            hasBanner={catalogId === COUNTRIES.INDIA && !isMobile && Boolean(freeBannerData?.desktop)}
          />
        </div>
      )}
      {hasDirectlyLandedFromGoogle &&
        isMobile &&
        pdpTopSuggestion &&
        pdpTopSuggestion !== "CG" &&
        catalogId === COUNTRIES?.INDIA && (
          <div className="sticky top-0 z-10 w-full translate-y-0 bg-white-900 py-2 opacity-100">
            <CategorySuggestionBanner
              isMobile={isMobile}
              cleverTapPageData={cleverTapPageData}
              pdpTopSuggestion={pdpTopSuggestion}
            />
          </div>
        )}
      {bannerDataObject?.show_banner && (
        <div
          className={`overflow-hidden transition-all duration-1000 ease-out
            ${showBanner ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}
        >
          <SingleImageBannerSection
            category={bannerDataObject}
            isFromSearch={false}
            isMobile={isMobile}
            dimensions={bannerDataObject?.dimensions}
          />
        </div>
      )}
      <div className="relative flex w-full flex-col justify-between border-b-2 border-lightGrey pb-10 md:flex-row md:gap-5 md:px-[112px] md:pb-[40px] md:pt-0 xll:px-[160px]">
        <div className={`z-1 w-full self-start md:sticky md:top-148 md:w-[53.3%] lg:w-2/4`} id="productGallery">
          {!isMobile && <Breadcrumb items={createBreadcrumbsData(breadCrumb)} catalogId={catalogId} />}
          <ProductDisplayGallery
            productImages={getProductImages(currentItem)}
            productReviewsAndRatings={get(currentItem, "productReviewsAndRatings")}
            productVideoLink={get(currentItem, "productContent.productVideoLink")}
            urlIdentifier={serverData?.urlIdentifier}
            skuCode={get(currentItem, "skuCode")}
            isMobile={isMobile}
            ctImageViewedData={pdpImageViewedData}
            titleForShareLink={currentItem?.productName}
            disclaimerText={currentItem?.disclaimerText}
          />
        </div>

        <div
          className={`relative mt-32 flex w-full flex-col gap-18  md:mt-0  md:w-[46.5%] md:pt-60`}
          id="productInformation"
        >
          {hasDirectlyLandedFromGoogle &&
            !isMobile &&
            pdpTopSuggestion &&
            pdpTopSuggestion !== "CG" &&
            catalogId === COUNTRIES?.INDIA && (
              <div className={`sticky top-0 z-40 w-full transition-all duration-300`}>
                <CategorySuggestionBanner
                  isMobile={isMobile}
                  cleverTapPageData={cleverTapPageData}
                  pdpTopSuggestion={pdpTopSuggestion}
                />
              </div>
            )}
          <div
            className={
              !isSameSku && productTypeId !== productTypes.FINISHED_GOOD ? "border-b-2 border-lightGrey pb-18" : ""
            }
          >
            <ProductPriceSection
              containerPadding={containerPadding}
              currentItem={currentItem}
              selectedCurrency={selectedCurrency}
              isMobile={isMobile}
              serverData={serverData}
              serverCustomerReviewData={serverCustomerReviewData}
              isOutOfStock={isOutOfStock}
              saleNudgeConfig={JSON.parse(saleNudgeConfigData || "{}")}
              monthlyOrdersCount={monthlyOrdersCount}
              productsAttrTagResponse={productsAttrTagData}
              isShowFreeDeliveryTag={isShowFreeDeliveryTag}
              isHidePriceAndOrderCount={isSameSku && deliveryType && productTypeId !== productTypes.FINISHED_GOOD}
            />
          </div>
          {isSameSku && deliveryType && productTypeId !== productTypes.FINISHED_GOOD && (
            <div className="flex flex-col gap-18 border-b-2 border-lightGrey pb-18">
              <div className={`flex flex-col gap-12 ${isMobile ? "px-16" : "max-w-[80%]"}`} id="prodSwitchContainer">
                <h2 className="text-16 font-600 text-fnp-500">{constants.AVAILABLE_OPTIONS}</h2>
                <ChooseDeliveryType commonCleverTapData={commonCleverTapData} selectedCurrency={selectedCurrency} />
              </div>
              <ProductPriceSection
                containerPadding={`${containerPadding} -mt-4`}
                currentItem={currentItem}
                selectedCurrency={selectedCurrency}
                isMobile={isMobile}
                serverData={serverData}
                serverCustomerReviewData={serverCustomerReviewData}
                isOutOfStock={isOutOfStock}
                saleNudgeConfig={JSON.parse(saleNudgeConfigData || "{}")}
                monthlyOrdersCount={monthlyOrdersCount}
                productsAttrTagResponse={productsAttrTagData}
                isShowFreeDeliveryTag={isShowFreeDeliveryTag}
                isHideTitleRating={true}
              />
            </div>
          )}

          {!isEmpty(serverVariantProducts) && (
            <>
              {!isEmpty(flavorList) && isMobile && (
                <div id="mobileFlavorSection" className="border-b-2 border-lightGrey pb-18" />
              )}
              <div className={`${containerPadding} border-b-2 border-lightGrey pb-18`}>
                <ComboComponents serverVariantProducts={serverVariantProducts} isMobile={isMobile} />
              </div>
            </>
          )}

          {
            <div className={`${containerPadding} border-b-2 border-lightGrey pb-18`}>
              <Typography variant="p" Tag="p" classes={labelStyle}>
                {constants.CHOOSE_DELIVERY_PREFERENCE}
              </Typography>
              {deliveryDetails?.isFreeDeliveryAvailable && (
                <FreeShippingInfo classes={"mb-12"} freeDeliveryText={freeDeliveryText} />
              )}
              {currentItem?.shippingDisplayOptions && currentItem?.shippingDisplayOptions?.showPincodeOrCity && (
                <div
                  id="location_lock"
                  className={`${isEmpty(deliveryDates) || isEmpty(deliveryDates?.deliveryDates) || isOutOfStock ? "" : "mb-20"}`}
                >
                  <Typography variant="p" Tag="p" classes={newLabelStyle}>
                    <MapPinIcon size={20} className="text-grey-500" />
                    {constants.DELIVERY_LOCATION}
                  </Typography>
                  {isMobile ? (
                    <MobileLocationLockSection
                      isLocationError={isNotServiceable || isOutOfStock}
                      fullProductDetails={fullProductDetails}
                      commonCleverTapData={commonCleverTapData}
                    />
                  ) : (
                    <DesktopLocationLockSection
                      isLocationError={isNotServiceable || isOutOfStock}
                      fullProductDetails={fullProductDetails}
                    />
                  )}
                </div>
              )}
              {!isNotServiceable &&
                cityOrPincode &&
                !isPreCheckoutOpen &&
                !isCustomisePreCheckoutOpen &&
                !isOutOfStock && (
                  <DeliveryDateAndtimeSlotSelection
                    currentItem={currentItem}
                    isMobile={isMobile}
                    selectedCurrency={selectedCurrency}
                    freeDeliveryText={freeDeliveryText}
                    onNudgeVisibilityChange={onNudgeVisibilityChange}
                    isShowFreeDeliveryTag={isShowFreeDeliveryTag}
                  />
                )}
            </div>
          }

          {hasPersonalizedOptions && !(showCustomiseNowButton && isCustomisePreCheckoutOpen) && !isOutOfStock && (
            <div
              id="personalization_section"
              className={
                isPersonalizationComplete || isTextPersonalizationStarted || isInlinePersonalization
                  ? `${containerPadding} flex flex-col gap-12 border-b-2 border-lightGrey pb-18`
                  : undefined
              }
            >
              <PersonalizedOptionSection
                currentItem={currentItem}
                isMobile={isMobile}
                onPersonalizationDrawerReady={onPersonalizationDrawerReady}
                onPersonalizationCompleteChange={onPersonalizationCompleteChange}
              />
            </div>
          )}

          {!isEmpty(bannerData?.data) && (
            <>
              <div className={`${containerPadding}`} id="pdp-campaign-banners">
                <WebNativeDisplayBanners bannerData={bannerData} campaignEventData={campaignEventData} />
              </div>
            </>
          )}
          {isShowAddonsOnPDP && !isOutOfStock && !isNotServiceable && addOnInfo?.addonsList?.[0]?.products.length && (
            <div id="pdpAddons" className="flex flex-col border-b-2 border-lightGrey pb-18 md:gap-16">
              <Typography classes="font-600 text-16 px-16 md:px-0" variant="h6" Tag="p">
                {MAKE_IT_EXTRA_SPECIAL}
              </Typography>
              <div className="flex flex-col md:gap-24">
                <AddonBody
                  isFromPDP={true}
                  isMobile={isMobile}
                  commonCleverTapData={cleverTapPDPEventData}
                  pdpAddonViewedKeyRef={pdpAddonViewedKeyRef}
                  isTrackingSuppressed={isPreCheckoutOpen || isCustomisePreCheckoutOpen}
                />
              </div>
            </div>
          )}

          {isShowPayLater && (
            <PayLater currentItem={currentItem} isMobile={isMobile} commonCleverTapData={commonCleverTapData} />
          )}
          {!isEmpty(serverOffersData) &&
            (!isMounted ? (
              <Skeleton customStyle={{ width: "100%", height: "150px" }} />
            ) : (
              !isSmartBuyClient && (
                <PdpOffers serverOffersData={serverOffersData} isMobile={isMobile} labelStyle={labelStyle} />
              )
            ))}

          {!isEmpty(get(currentItem, "productContent")) && (
            <>
              <div className={`${containerPadding}`}>
                <AccordionSection currentItem={currentItem} isMobile={isMobile} />
              </div>
            </>
          )}
          {isMounted && (
            <BuyNowSection
              currentItem={currentItem}
              fullProductDetails={fullProductDetails}
              isMobile={isMobile}
              isNotServiceable={isNotServiceable}
              isOutOfStock={isOutOfStock}
              onButtonClick={onGa4EventBuyNow_AddToCart}
              commonCleverTapData={cleverTapPDPEventData}
              freeDeliveryText={freeDeliveryText}
              onOpenPersonalization={onOpenPersonalization}
              isPersonalizationComplete={isPersonalizationComplete}
              onPersonalizationCompleteChange={onPersonalizationCompleteChange}
              onCustomisePreCheckoutOpenChange={onCustomisePreCheckoutOpenChange}
              onPreCheckoutOpenChange={onPreCheckoutOpenChange}
              onNudgeVisibilityChange={onNudgeVisibilityChange}
              isShowFreeDeliveryTag={isShowFreeDeliveryTag}
              isSameSku={isSameSku}
              isSameDayNudgeVisible={nudgeVisibility.isSameDayNudgeVisible}
              isLimitedCatalogueNudgeVisible={nudgeVisibility.isLimitedCatalogueNudgeVisible}
            />
          )}
        </div>
      </div>

      <ZoomGallery
        productImages={getProductImages(currentItem)}
        productVideoLink={get(currentItem, "productContent.productVideoLink")}
        ctImageViewedData={pdpImageViewedData}
      />

      <ProductDetailWidgetSection
        currentItem={currentItem}
        isMobile={isMobile}
        serverCustomerReviewData={serverCustomerReviewData}
      />

      <CommonConditionalComponents
        isMobile={isMobile}
        commonCleverTapData={cleverTapPDPEventData}
        isAddonModalSuppressed={isMobile}
      />

      {!isEmpty(pdpFooterLinks) && pdpFooterLinks?.mainList && (
        <ExploreMore data={pdpFooterLinks} isMobile={isMobile} />
      )}

      {isMobile && (
        <div className="px-16">
          <Breadcrumb items={createBreadcrumbsData(breadCrumb)} catalogId={catalogId} />
        </div>
      )}

      {isShowCartEmpty && <ClearCart isMobile={isMobile} selectedCurrency={selectedCurrency} />}

      <TrustMetrics metrics={metrics} isMobile={isMobile} />
      <HiddenInputs
        productDetails={fullProductDetails}
        currentItem={currentItem}
        currencyCode={selectedCurrency?.currency?.currencyCode}
        deliveryDetailsData={deliveryDetailsData}
        isMobile={isMobile}
        fnpSalesChannelEnumId={
          typeof window !== "undefined" ? getFnpSalesChannelInfo(isMobile)?.fnpSalesChannelEnumId : ""
        }
      />
    </div>
  );
};
ProductDetailPage.propTypes = {
  serverData: PropTypes.object.isRequired,
  serverOffersData: PropTypes.array.isRequired,
  serverVariantProducts: PropTypes.array,
  serverVariantLabel: PropTypes.string,
  serverVariantType: PropTypes.string,
  serverVariantFlavor: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  serverSelectedCurrency: PropTypes.object,
  fullProductDetails: PropTypes.object.isRequired,
  breadCrumb: PropTypes.object,
  catalogId: PropTypes.string.isRequired,
  pdpFooterLinks: PropTypes.object,
  serverCustomerReviewData: PropTypes.object.isRequired,
  monthlyOrdersCount: PropTypes.number,
  isShowFreeDeliveryTag: PropTypes.bool,
  freeDeliveryText: PropTypes.string,
  freeBannerData: PropTypes.object,
};
export default ProductDetailPage;
